import React, { FC } from 'react'
import { Grid } from 'transfix-ui/core'
import { ITeamMember } from 'apps/fleet-planner/types'
import formatPhone from 'utils/formatPhone'

interface ITeamMemberContactDisplayProps {
  teamMember: ITeamMember
}

export const TeamMemberContactDisplay: FC<ITeamMemberContactDisplayProps> = ({ teamMember }) => {
  const { cellPhone, phone } = teamMember || {}
  return (
    <Grid container spacing={1} direction='column'>
      <Grid item>
        <div className='fs-mask'>
          P: {phone ? formatPhone(phone, { removeCountryCode: '+1' }) : '---'}
        </div>
      </Grid>
      <Grid item>
        <div className='text-secondary fs-mask'>
          C: {cellPhone ? formatPhone(cellPhone, { removeCountryCode: '+1' }) : '---'}
        </div>
      </Grid>
    </Grid>
  )
}
